import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Calendar from '../../../Part_Sample/Calendar';
import { isEmpty, handleDownloadCSV, makeTimeString } from '../../../Common/Common';

export default class Export_PPD extends Component {
	constructor(props) {
		super(props);
		let date = new Date();
		let from_date = new Date(date.getFullYear(), date.getMonth() - 1, 1);
		let to_date = new Date(date.getFullYear(), date.getMonth(), 0); //the last day of last month

		this.state = {
			selected_from_date: from_date,
			selected_to_date: to_date,
			is_show_from_calendar: false, //show "from" calendar
			is_show_to_calendar: false, //show "to" calendar

			progress_status: '',
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('PPD_Data');
	}

	handleChangeToCalDate = (selected_date) => {
		let now = new Date();
		let check_date = new Date(selected_date);
		now.setHours(0, 0, 0);
		check_date.setHours(0, 0, 0);

		if (check_date > now) {
			this.setState({
				selected_to_date: now,
				is_show_to_calendar: false
			});
		} else {
			this.setState({
				selected_to_date: selected_date,
				is_show_to_calendar: false
			});
		}
	}

	handleChangeFromCalDate = (selected_date) => {
		let now = new Date();
		let check_date = new Date(selected_date);
		now.setHours(0, 0, 0);
		check_date.setHours(0, 0, 0);

		if (check_date > now) {
			this.setState({
				selected_from_date: now,
				is_show_from_calendar: false
			});
		} else {
			this.setState({
				selected_from_date: selected_date,
				is_show_from_calendar: false
			});
		}
	}

	toggleToCalendar = () => {
		this.setState({ is_show_to_calendar: !this.state.is_show_to_calendar });
	}

	toggleFromCalendar = () => {
		this.setState({ is_show_from_calendar: !this.state.is_show_from_calendar });
	}

	handleLeftButtonAction = () => {
		let from = new Date(this.state.selected_from_date);
		let to = new Date(this.state.selected_to_date);
		//to.setDate(to.getDate - 31);

		if (to.getTime() < from.getTime()) {
			window.app.showToast(this.props.receiver.getString('start_date_end_date_one_month'), 3000);
			return;
		}

		window.app.showLoading();
		this.setState({ progress_status: this.props.receiver.getString('processing') })
		this.props.receiver.loadPPDPointList();
	}

	rcvLoadPPDPointList = (ppd_point_list) => {
		if (ppd_point_list != null) {
			let from = new Date(this.state.selected_from_date);
			let to = new Date(this.state.selected_to_date);

			// DB time end date is 0000 hours, so must add 1
			to.setDate(to.getDate() + 1);

			// {"fy":year,"fm":month,"fd":day,"ty":year,"tm":month,"td":day,"points":[ppd point id,…]}
			let param = {};
			param.fy = from.getFullYear();
			param.fm = from.getMonth() + 1;
			param.fd = from.getDate();
			param.ty = to.getFullYear();
			param.tm = to.getMonth() + 1;
			param.td = to.getDate();
			param.points = ppd_point_list;

			this.props.receiver.getPPD(param);
		} else {
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
		}
	}

	rcvGetPPD = (response) => {
		if (response.result != null) {
			if (response.result == 'NG') {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('fail'), 3000);
				return;
			}
		}

		let today = new Date();

		let file_name = 'PPDData' + today.getFullYear()
			+ (today.getMonth() < 10 ? '0' : '') + (today.getMonth() + 1)
			+ (today.getDate() < 10 ? '0' : '') + (today.getDate())
			+ '.csv';

		let csv = [];
		let from = [];
		from.push(this.props.receiver.getString('from'));
		from.push(response.fy);
		from.push(response.fm);
		from.push(response.fd);
		csv.push(from.join(","));
		let to = [];
		to.push(this.props.receiver.getString('to'));
		to.push(response.ty);
		to.push(response.tm);
		to.push(response.td);
		csv.push(to.join(","));

		csv.push("");
		csv.push('"","kWh"');

		this.getPPDData(response.data, csv);
		handleDownloadCSV(csv.join("\n"), file_name);

		this.setState({ progress_status: this.props.receiver.getString('wait_download') })
		window.app.hideLoading();
	}

	getPPDData(data, csv) {
		// 1. Get the headers using the point names
		let headers2 = this.getHeaders2(data);
		csv.push(headers2.join(","));

		/*
		 * At first, data from controller is sort by device id.
		 * Eg. "data":{point id:[[date,cool,heat,standby,fan,heater],…], point id:[[date,cool,heat,standby,fan,heater],…],}
		 * 
		 * We need to rearrange data to sort by datetime.
		 * *Eg. Convert to: [datetime,cool,heat,standby,fan,heater,cool,heat,standby,fan,heater]
		 */

		// 2. Get the series of time (i.e. every 15 min between start and end dates)
		let time_series = this.getTimeSeries();

		// 3. Get the list of ids from data
		let id_list = Object.keys(data);

		//Add "Date & Time", "Cool", "Heat","Standby", "Fan", "Heater" between point names and actual data
		let headers3 = [];
		headers3.push(this.props.receiver.getString('sel_date'));
		for (let id of id_list) {
			headers3.push(this.props.receiver.getString('cool'), this.props.receiver.getString('heat'), this.props.receiver.getString('standby'), this.props.receiver.getString('fan'), this.props.receiver.getString('heater'));
		}
		csv.push(headers3.join(","));

		/*
		 * Steps 4 and 5 are to make sure there's no missing data
		 * by creating a default hash with all empty strings
		 * and then populate the hash with data from controller
		 */

		// 4. At first, populate all data default with empty string
		// Eg. {datetime: {id : ["","","","",""], ...}, datetime: {id : ["","","","",""], ...},...}
		let temp_data = {};
		for (let datetime of time_series) {
			temp_data[datetime] = {};
			for (let id of id_list) {
				temp_data[datetime][id] = ["", "", "", "", ""];
			}
		}

		// 5. Populate data by finding the time that corresponds to timeseries
		// Eg. {datetime: {id : ["","",300,200,""], ...}, datetime: {id : [100,"","","",""], ...},...}
		for (let id of id_list) {
			let device_data = data[id];
			for (let device_data_row of device_data) {
				// For every row in device_data find the corresponding data for each timeseries
				let time = device_data_row.splice(0, 1);
				temp_data[time][id] = [...device_data_row];
			}
		}

		/*
		 * 6. Convert the hash into array, and insert into csv
		 * Eg. from {datetime: {id : ["","",300,200,""], ...}, datetime: {id : [100,"","","",""], ...},...}
		 * convert to [datetime,cool,heat,standby,fan,heater,cool,heat,standby,fan,heater]
		 */
		for (let datetime in temp_data) {
			let row_data = [];
			row_data.push(datetime)
			let datetime_data = temp_data[datetime];
			for (let id in datetime_data) {
				row_data = row_data.concat(datetime_data[id]);
			}
			csv.push(row_data.join(","));
		}
	}

	getTimeSeries = () => {
		let time_series = [];
		let start = new Date(this.state.selected_from_date);
		let end = new Date(this.state.selected_to_date);

		start.setHours(0, 0, 0);
		//end.setDate(end.getDate() - 1);
		end.setHours(23, 45, 0); // End at 2345

		while (start <= end) {
			let year = start.getFullYear();
			let month = makeTimeString(start.getMonth() + 1);
			let date = makeTimeString(start.getDate());
			let hour = makeTimeString(start.getHours());
			let min = makeTimeString(start.getMinutes());
			time_series.push(year + month + date + hour + min);

			start.setMinutes(start.getMinutes() + 15)
		}

		return time_series;
	}

	getHeaders2 = (data) => {
		let headers2 = [];
		//headers2.push(this.props.receiver.getString('sel_date'));
		headers2.push("");
		let id_list = Object.keys(data);
		for (let id of id_list) {
			let point_name = id;
			let point_info = window.app.state.point_list[id];
			if (!isEmpty(point_info)) point_name = point_info.name;
			headers2.push(point_name, "", "", "", "");
		}

		return headers2;
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto',
		}

		let cal_width = this.props.width - 40;
		let cal_height = 200;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('export_ppd')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ boxShadow: 'rgb(0 0 0 / 10%) 1px 1px 2px 2px', padding: 20, margin: 20, borderRadius: 20 }}>
						{/* From Date */}
						<div style={{ display: 'inline-block', width: '50%' }}>
							<span style={{ display: 'block' }}>{this.props.receiver.getString("from")}</span>
							<div onClick={this.toggleFromCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
								<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_from_date.toLocaleDateString()}</span>
							</div>
						</div>

						{/* To Date */}
						<div style={{ display: 'inline-block', width: '50%' }}>
							<span style={{ display: 'block' }}>{this.props.receiver.getString("to")}</span>
							<div onClick={this.toggleToCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
								<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_to_date.toLocaleDateString()}</span>
							</div>
						</div>
					</div>

					<div style={{ width: this.props.width }}>
						<span className='title'>{this.state.progress_status}</span>
					</div>

					<div id="toCalendar" className='slideInDown' style={{}}>
						<Calendar
							onSelect={this.handleChangeToCalDate}
							style={{ visibility: this.state.is_show_to_calendar ? 'visible' : 'hidden' }}
							width={cal_width}
							height={cal_height}
							left={(this.props.width - 20) * 0.05}
							max_date={new Date()}
							selected_date={this.state.selected_to_date}
						/>
					</div>

					<div id="fromCalendar" className='slideInDown' style={{}}>
						<Calendar
							onSelect={this.handleChangeFromCalDate}
							style={{ visibility: this.state.is_show_from_calendar ? 'visible' : 'hidden' }}
							width={cal_width}
							height={cal_height}
							left={(this.props.width - 20) * 0.05}
							max_date={new Date()}
							selected_date={this.state.selected_from_date}
						/>
					</div>

				</div>
			</div>
		)
	}
}